import React from 'react'
import { Box, Flex, Heading } from '@moonpig/launchpad-components'
import { IllustrationCard } from '@moonpig/launchpad-assets'
import { Region } from '@moonpig/web-core-types'
import {
  BrandedBenefitText,
  BrandedBenefitsBox,
  FloatingPig,
  SuccessTickOutline,
} from './BenefitBox.styles'
import { useAuthenticationLocaleText } from '../../text-localisation'

export const BenefitBox: React.FC<{ region: Region }> = ({ region }) => {
  const localiseText = useAuthenticationLocaleText()

  return (
    <BrandedBenefitsBox
      borderRadius={{ xs: 4, md: '0 16px 16px 0' }}
      py={10}
      px={{ xs: 7, md: 0 }}
      display={{ xs: 'none', md: 'block' }}
      data-testid="login-benefits"
      mx={{ xs: 6, md: 0 }}
      mb={{ xs: 10, md: 0 }}
    >
      <Heading
        level="h2"
        mb={{ xs: 8, md: 10 }}
        textAlign={{ md: 'center' }}
        pl={{ xs: 6, md: 5, lg: 0 }}
        typography={{ xs: 'typeMobileDisplay03', md: 'typeDesktopDisplay04' }}
      >
        {localiseText('auth_wizard.benefits_title')}
      </Heading>
      <Box
        px={{ xs: 6 }}
        maxWidth={{ xs: '100%', md: '320px' }}
        margin={{ md: 'auto' }}
      >
        <BenefitItem
          title={localiseText('auth_wizard.benefits.reminders_title')}
          content={localiseText('auth_wizard.benefits.reminders_content')}
        />
        <BenefitItem
          title={localiseText('auth_wizard.benefits.convenient_title')}
          content={localiseText('auth_wizard.benefits.convenient_content')}
        />
        <BenefitItem
          title={localiseText('auth_wizard.benefits.tracking_title')}
          content={localiseText('auth_wizard.benefits.tracking_content')}
        />
      </Box>
      <Box textAlign="center" mt={8}>
        {region === 'nl' ? (
          /* istanbul ignore next */ <IllustrationCard width="142px" />
        ) : (
          <FloatingPig />
        )}
      </Box>
    </BrandedBenefitsBox>
  )
}

const BenefitItem: React.FC<{ title: string; content: string }> = ({
  title,
  content,
}) => {
  return (
    <Flex>
      <Box mr={6}>
        <SuccessTickOutline />
      </Box>
      <Box mb={10}>
        <BrandedBenefitText
          typography={{ xs: 'typeMobileDisplay03', md: 'typeDesktopDisplay04' }}
          mb={3}
          display="block"
        >
          {title}
        </BrandedBenefitText>
        <BrandedBenefitText display="block">{content}</BrandedBenefitText>
      </Box>
    </Flex>
  )
}
